import axios from '@plugins/axios';

class ReportePorFiguraService {
    getDetallado(filters = {}, options = {}) {
        if (Object.hasOwnProperty.call(filters, 'consolidado')) {
            filters['consolidado'] = filters['consolidado'] ? 1 : 0;         
        }

        if (Object.hasOwnProperty.call(filters, 'force_comercio_grouping')) {
            filters['force_comercio_grouping'] = filters['force_comercio_grouping'] ? 1 : 0;         
        }

        return axios({
            url: `reporte/venta/figura/detallado`,
            method: 'GET',
            params: filters,
            ...options
        });
    }
    getConsolidado(filters = {}, options = {}) {
        if (Object.hasOwnProperty.call(filters, 'consolidado')) {
            filters['consolidado'] = filters['consolidado'] ? 1 : 0;         
        }

        if (Object.hasOwnProperty.call(filters, 'consolidado')) {
            filters['force_comercio_grouping'] = filters['force_comercio_grouping'] ? 1 : 0;         
        }

        return axios({
            url: `reporte/venta/figura/consolidado`,
            method: 'GET',
            params: filters,
            ...options
        });
    }
}

export const BaseReportePorFiguraService = ReportePorFiguraService

export default new ReportePorFiguraService();